import { FC } from 'react'
import { NonUndefined } from 'react-hook-form'

import LoadingButton from '@/components/loading-button'
import { ActionTimer } from '@/hooks/useActionTimer'
import { Logging } from '@/out/logging'
import { Label } from '@/components/ui/label'

type Props = {
  configuration: NonUndefined<Logging['sumologic']>
  timer: ActionTimer
  onRemove: () => void
}

const SumologicDetails: FC<Props> = ({ configuration, timer, onRemove }) => {
  return (
    <>
      <div className="pt-2 mb-6 space-y-3">
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Collector URL:</Label>
          <span className="block text-sm font-medium truncate">{configuration.collectorUrl}</span>
        </div>
      </div>
      <LoadingButton timer={timer} size="sm" onClick={onRemove} variant="outline-destructive">
        Disconnect
      </LoadingButton>
    </>
  )
}

export default SumologicDetails
